export const TIME_FORMAT_SHORT = "HH:mm";
export const TIME_FORMAT = "HH:mm:ss";
export const TIME_FORMAT_LONG = "HH:mm:ss.SSS";
export const DATE_FORMAT = "DD/MM/YYYY";
export const TIME_FORMAT_WITH_DATE = "HH:mm:ss - DD/MM/YYYY";
export const DATE_FORMAT_WITH_TIME = "DD/MM/YYYY - HH:mm:ss";
export const API_DATE_FORMAT = "YYYY-MM-DD";
